import { reducers } from 'redux/core'


const start = (name) => reducers.models.tours.setTour({ name, isStarted: true })

const end = (name) => reducers.models.tours.setTour({ name, isStarted: false })


export default {
  start,
  end,
}
